import { type VueGtmPlugin, createGtm, useGtm } from "@gtm-support/vue-gtm";
import { CONFIG } from "@shared/config";
import { internalPostMessage } from "@shared/utils/iframe";

import { isValidGtmId, pushGtmConsentDefault } from "@shared/app/gtm/consent";

const {
  application: {
    initialization: {
      tracking: { gtmContainerId, gtmContainerIdV2, postMessage, targetOrigin },
    },
  },
} = CONFIG;

const { DEV, MODE } = import.meta.env;

export const trackEvent = <T extends object>(event: T): void => {
  if (postMessage) {
    internalPostMessage(event, targetOrigin);
    return;
  }
  useGtm()?.trackEvent(event);
};

export const initGtm = (): VueGtmPlugin => {
  pushGtmConsentDefault();
  const id = gtmContainerIdV2 || gtmContainerId;

  return createGtm({
    // NOTE: This plugin throws an error when an `undefined` GTM-ID is provided.
    // We default to an `id` that does not throw an error if it is undefined.
    // See: https://github.com/gtm-support/vue-gtm/issues/27
    id: isValidGtmId() ? id.trim() : "GTM-DEMO",
    enabled: isValidGtmId() && MODE === "production",
    debug: DEV,
  });
};
